import memoize, { Options } from "fast-memoize";
import debounce from "lodash-es/debounce";

interface DebounceSettings {
  /**
   * @see _.leading
   */
  leading?: boolean;
  /**
   * @see _.maxWait
   */
  maxWait?: number;
  /**
   * @see _.trailing
   */
  trailing?: boolean;
}

// Same as lodash debounce but also checks function arguments
// So if you called debouncedFunc(1) and debouncedFunc(2) - it
// will be two independently debounced calls.
const memoizedDebounce = <T extends (...args: any) => any>(
  func: T,
  wait?: number,
  options?: DebounceSettings,
  memoizeOptions?: Options<T>
) => {
  // FIXME: fast-memoize only remembers one cached value, sometimes we'd need more
  const mem = memoize(() => debounce(func, wait, options), memoizeOptions);
  return function (...args: any[]) {
    // @ts-ignore
    mem.apply(this, args).apply(this, args);
  };
};

export default memoizedDebounce;
